/** @jsx jsx */
import type { HTMLAttributes } from 'react';
import React, { forwardRef } from 'react';
import { jsx } from '@balance-web/core';
import { Box } from '@balance-web/box';
import { useTheme } from '@balance-web/theme';

import { CONTROL_HEIGHTS, GUTTER } from './constants';
import type { SegmentedControlSizeType } from './types';

type SegmentedControlWrapperProps = {
  block: boolean;
  size: SegmentedControlSizeType;
} & HTMLAttributes<HTMLDivElement>;
export const Wrapper = forwardRef<HTMLDivElement, SegmentedControlWrapperProps>(
  ({ block, size, ...props }, ref) => {
    const { semantic, typography, radii } = useTheme();

    return (
      <Box
        ref={ref}
        css={{
          background: semantic.colour.neutral.container.background,
          backgroundClip: 'padding-box',
          borderRadius: radii.small,
          boxSizing: 'border-box',
          cursor: 'pointer',
          display: block ? 'flex' : 'inline-flex',
          flex: block ? 1 : undefined,
          // `small` at both sizes, as inputs do: an xsmall input keeps the
          // small font too, and the two sit side by side.
          fontSize: typography.fontSize.small,
          fontWeight: typography.fontWeight.medium,
          height: CONTROL_HEIGHTS[size],
          outline: 0,
          padding: GUTTER,
          position: 'relative',
        }}
        {...props}
      />
    );
  }
);
Wrapper.displayName = 'SegmentedControlWrapper';
